import React from 'react';

import { FlySpinnerLoader } from '@fly/shared-ui';

import styles from '../../Dashboard.module.less';

interface LoadingOverlayProps {
  isVisible: boolean;
  size?: number;
  className?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  size = 24,
  className,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={`${styles.overlay} ${className || ''}`}>
      <FlySpinnerLoader size={size} />
    </div>
  );
};
